import { ApiResponse, SubjectResponse } from 'logic/api-models/api-models';
import { axiosApiClient } from 'logic/axios/axios-api-guest-client';

export const subjectApi = {
  fetchSubjects: () => axiosApiClient().get<ApiResponse<SubjectResponse>>('/subject'),
};
